<template>
  <div>
    <InWarrantyInfoBlock v-if="isInWarranty" :claim />

    <OutOfWarrantyInfoBlock
      v-if="!isInWarranty"
      :customer-issues="claim.customerIssues"
      :label-return="claim.labelReturn"
      :warranty-state="claim.declaredWarrantyState"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { isEmpty } from '@backmarket/utils/object/isEmpty'

import type { Claim } from '~/api/care-folders/types/claim'

import InWarrantyInfoBlock from './components/InWarrantyInfoBlock/InWarrantyInfoBlock.vue'
import OutOfWarrantyInfoBlock from './components/OutOfWarrantyInfoBlock/OutOfWarrantyInfoBlock.vue'

const props = defineProps<{
  claim: Claim
}>()

const isInWarranty = computed(
  () =>
    isEmpty(props.claim.declaredWarrantyState) ||
    props.claim.declaredWarrantyState === 'IN_WARRANTY',
)
</script>
